import "core-js/modules/es.string.link.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "col-xl-4 col-lg-4 col-md-6 order-xl-2 mb-2 mb-xl-0"
};
var _hoisted_2 = {
  "class": "card card-profile shadow"
};
var _hoisted_3 = {
  "class": "card-body pt-0 pt-md-4"
};
var _hoisted_4 = {
  "class": "text-center mt-2"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  "class": "ni education_hat mr-2"
}, null, -1);

var _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", {
  "class": "my-2"
}, null, -1);

var _hoisted_7 = {
  "class": "col"
};
var _hoisted_8 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-5"
};
var _hoisted_9 = {
  "class": "heading"
};
var _hoisted_10 = {
  "class": "description"
};
var _hoisted_11 = {
  "class": "heading"
};
var _hoisted_12 = {
  "class": "description"
};
var _hoisted_13 = {
  "class": "heading"
};
var _hoisted_14 = {
  "class": "description"
};

var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  "class": "row"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: $options.link
  }, {
    "default": _withCtx(function () {
      return [_hoisted_5, _createTextVNode(_toDisplayString($props.communities.title), 1)];
    }),
    _: 1
  }, 8, ["to"])]), _hoisted_6, _createElementVNode("p", null, _toDisplayString($props.communities.about), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, _toDisplayString($props.communities.subscribers), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("label.subscribers")), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_11, _toDisplayString($props.communities.num_authors), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("label.posters")), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_13, _toDisplayString($props.communities.num_pending), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("label.posts")), 1)])])]), _createVNode(_component_el_button, {
    loading: $data.subscribeLoad,
    type: $data.isJoined ? 'neutral' : 'primary',
    "class": "my-4",
    onMouseenter: _cache[0] || (_cache[0] = function ($event) {
      return $data.showLeave = true;
    }),
    onMouseleave: _cache[1] || (_cache[1] = function ($event) {
      return $data.showLeave = false;
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $data.isJoined ? $options.unSubscribe() : $options.subscribe();
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t($data.isJoined ? $data.showLeave ? "button.leave" : "button.joined" : "button.subscribe")), 1)];
    }),
    _: 1
  }, 8, ["loading", "type"])]), _hoisted_15])])]);
}